import { HERMES_URL } from "resources/constants";
import authClient from "lib/axios/clients";

export const getAthenaTenants = () => {
  const config = {
    method: "GET",
    url: `${HERMES_URL}/athena_tenants`
  };

  return authClient.request(config);
};

export const createAthenaTenant = tenant => {
  const config = {
    method: "POST",
    url: `${HERMES_URL}/athena_tenants`,
    data: tenant
  };

  return authClient.request(config);
};

export const deleteAthenaTenant = tenantId => {
  const config = {
    method: "POST",
    url: `${HERMES_URL}/athena_tenants/delete_tenant`,
    data: { athena_tenant_id: tenantId }
  };

  return authClient.request(config);
};

export const partialUpdateAthenaTenant = athenaTenant => {
  const config = {
    method: "PATCH",
    url: `${HERMES_URL}/athena_tenants/${athenaTenant.id}`,
    data: athenaTenant
  };

  return authClient.request(config);
};

export const publishEventCreateAthenaTenant = companyId => {
  const config = {
    method: "POST",
    url: `${HERMES_URL}/athena_tenants/create_tenant`,
    data: { company_id: companyId }
  };

  return authClient.request(config);
};
